export default "__VITE_ASSET__D4ZJGcTl__"